import { DELIVERY_STATUS, PICKUP_STATUS } from "./helper";
import Konsole from "./konsole/Konsole";
const DiscountPrice = (price: number, store: any,selectedType:any) => {
  Konsole.log('selectedTypeFromDis',selectedType)
  if (selectedType == DELIVERY_STATUS) {
    if (store?.store_discount?.delivery_discount) {
      return (
        (Number(price) * Number(store?.store_discount?.delivery_discount)) / 100
      );
    } else {
      return 0;
    }
  } else if (selectedType == 1) {
    if (store?.store_discount?.pickup_discount) {
      return (
        (Number(price) * Number(store?.store_discount?.pickup_discount)) / 100
      );
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};

export default DiscountPrice;
